export default [
  {
    id: 'epson',
    name: 'Epson',
  },
  {
    id: 'star',
    name: 'Star',
  },
];
